import { Input, Modal, Popover } from 'antd';
import React from 'react';
import style from './modal.module.scss';
import { StarFilled, StarOutlined, ShoppingOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { CustomButton, message } from '../../../utils/Utils';
import {useEffect} from 'react';

const OpenCombo = (props) => {
  const {
    state,
    set,
    combo,
    setOrders,
    orders,
    total,
    setTotal,
    quantity,
    setQuantity,
    subTotals,
    setSubTotals,
    isView,
  } = props;
  const { container, tableItem, tableHeader, table } = style;
  useEffect(() => {
    //init subTotals and quantity
    const subTotalsInit = {};
    const quantityInit = {};
    
    combo.products.forEach((product) => {
      subTotalsInit[product.product._id] = product.minQuantity * (product.product.pharmacyPrice - product.product.pharmacyPrice * product.discount);
      quantityInit[product.product._id] = quantity[product.product._id] >= product.minQuantity? quantity[product.product._id] : product.minQuantity;
    });

    setSubTotals(subTotalsInit);
    setQuantity(quantityInit);

    //init total
    const thisComboTotal = combo.products.reduce((acc, product) => {
      return acc + (product.minQuantity * (product.product.pharmacyPrice - product.product.pharmacyPrice * product.discount));
    }, 0);
    setTotal({ ...total, [combo._id]: thisComboTotal });

  }, [combo]);
  const handleChangeQuantity = (product, action, e) => {
    e?.preventDefault();
    const id = product.product._id, 
      price = product.product.pharmacyPrice.toFixed(2), 
      min = product.minQuantity, 
      max = product.maxQuantity, 
      description = product.product.description,
      discount = product.discount;
    if (action === 'change') {
      const newValue = parseInt(e.target.value) || 0;
      if (newValue > quantity[id]) {
        const newQuantity = { ...quantity, [id]:newValue};
        const newSubTotals = { ...subTotals, [id]: newValue * (price - price * discount)};
        setQuantity(newQuantity);
        setSubTotals(newSubTotals);
        const newTotal = total[combo._id] + ((newValue - quantity[id]) * (price - price * discount));
        setTotal({ ...total, [combo._id]: newTotal });
      }
      else {
        if (quantity[id] === min && newValue === min) {
          message.error(`No puedes pedir menos de ${min} unidades de ${description}`, 0.7);
          return;
        }
        const newQuantity = { ...quantity, [id]: newValue };
        const newSubTotals = { ...subTotals, [id]: newValue * (price - price * discount) };
        setQuantity(newQuantity);
        setSubTotals(newSubTotals);
        const newTotal = (total[combo._id] - ( (quantity[id] - newValue) * (price - price * discount)).toFixed(2)).toFixed(2);
        setTotal({ ...total, [combo._id]:newTotal*1});
      }

    }

    if (action === 'plus') {
      if (quantity[id] < max || max === 0) {
        const newQuantity = { ...quantity, [id]: quantity[id] + 1 };
        const newSubTotals = { ...subTotals, [id]: subTotals[id] + (price - price * discount)};
        setQuantity(newQuantity);
        setSubTotals(newSubTotals);
        setTotal({ ...total, [combo._id]: total[combo._id] + (price - price * discount) });
      } else {
        message.error(`No puedes comprar más de ${max} unidades de ${description}`, 0.7);
      }
    }
    if (action === 'minus') {
      if (quantity[id] > min) {
        const newQuantity = { ...quantity, [id]: quantity[id] - 1 };
        const newSubTotals = { ...subTotals, [id]: subTotals[id] - (price - price * discount) };
        setQuantity(newQuantity);
        setSubTotals(newSubTotals);
        setTotal({ ...total, [combo._id]: total[combo._id] - (price - price * discount) });
      } else {
        message.error(`No puedes pedir menos de ${min} unidades de ${description}`, 0.7);
      }
    }    
  };

  const handleSubmit = () => {
    //if order doesn't exist create it
    const orderExist = orders.find((order) => order.combo === combo._id);
    
    if (! orderExist) {
      const newOrder = {
        combo: combo._id,
        products: [],
        quantity: 1,
        total: total[combo._id],
      };
      combo.products.forEach((product) => {
        newOrder.products.push({
          product: product.product._id,
          quantity: quantity[product.product._id],
        });
      });

      const totalProducts = newOrder.products.reduce((acc, product) => {
        return acc + product.quantity;
      }, 0);

      if(!combo.closedCombo && totalProducts < combo.totalItemsQuantity){
        message.error(`No puedes pedir menos de ${combo.totalItemsQuantity} unidades de productos para este combo`, 1.5);
        return;
      }

      if(combo.closedCombo && totalProducts !== combo.totalItemsQuantity){
        message.error(`Este combo debe llevar exactamente ${combo.totalItemsQuantity} unidades de productos`, 1.5);
        return;
      }

      setOrders([...orders, newOrder]);
      const resetedQuantity = {};
      setQuantity(resetedQuantity);
      set(!state);  
    } else {
      let okToClose = true;
      const newOrders = orders.map((order) => {
        if (order.combo === combo._id) {
          const newOrder = {
            combo: order.combo,
            products: [],
            quantity: orders.find((order) => order.combo === combo._id).quantity,
            total: total[combo._id],
          };
          combo.products.forEach((product) => {
            newOrder.products.push({
              product: product.product._id,
              quantity: quantity[product.product._id],
            });
          });

          const totalProducts = newOrder.products.reduce((acc, product) => {
            return acc + product.quantity;
          }, 0);
    
          if(!combo.closedCombo && totalProducts < combo.totalItemsQuantity){
            message.error(`No puedes pedir menos de ${combo.totalItemsQuantity} unidades de productos para este combo`, 1.5);
            okToClose = false;
            return order;
          }

          if(combo.closedCombo && totalProducts !== combo.totalItemsQuantity){
            message.error(`Este combo debe llevar exactamente ${combo.totalItemsQuantity} unidades de productos`, 1.5);
            okToClose = false;
            return order;
          }

          return newOrder;
        } else {
          return order;
        }
      });
      if(!okToClose){
        return;
      }
      setOrders(newOrders);
      const resetedQuantity = {};
      setQuantity(resetedQuantity);
      set(!state);
    }
  };

  const handleClose = () => {
    const resetedQuantity = {};
    setQuantity(resetedQuantity);
    set(!state);
  };

  return (
    <Modal
      visible={state}
      footer={null}
      onCancel={handleClose}
      width='1300px'
    >
      <div className={container}>
        <div>
          <div>
            <div>
              <h2>{combo.name}</h2>
              {combo.starred? <StarFilled /> : <StarOutlined />}
            </div>
            <div>
              {`(${combo.products.length} artículos)`}
            </div>
          </div>
          <div>
            <h4>Cantidad {combo.closedCombo ? 'requerida' : 'mínima'} de productos: {combo.totalItemsQuantity}</h4>
            <Popover content={<p>Combo abierto: El combo tiene una cantidad mínima de productos.<br/>Combo cerrado: El combo tiene una cantidad fija de productos.</p>}><h4>Tipo de combo: {combo.closedCombo ? 'Cerrado' : 'Abierto'}</h4></Popover>
          </div>
          {!isView && <div>
            <h3>Total</h3>
            <ShoppingOutlined />
            <h3>${total[combo._id]?.toFixed(2)}</h3>
          </div>}
        </div>
        <div>
          <div className={table}>
            <div>
              <div className={tableHeader}>
                <div>Producto</div>
                <div>Mín.</div>
                <div>Máx.</div>
                <div>Pcio.Púb. C/IVA</div>
                <div>Pcio.Fcia. C/IVA</div>
                <div>Descuento</div>
                <div>Pcio.Oferta C/IVA</div>
                {!isView && <div>Pedidos</div>}
                {!isView && <div>Total con descuento</div>}
              </div>
              <div>
                {
                  combo.products.map((product) => (
                    <div className={tableItem} key={product.product._id}>
                      <Popover content={product?.product?.description}>
                        <div>{product?.product?.description}</div>
                      </Popover>
                      <div>{product?.minQuantity}</div>
                      <div>{product?.maxQuantity}</div>
                      <div>${product?.product?.publicPrice.toFixed(2)}</div>
                      <div>${product?.product?.pharmacyPrice.toFixed(2)}</div>
                      <div>{product?.discount * 100}%</div>
                      <div>${(product?.product?.pharmacyPrice - (product?.product?.pharmacyPrice * product?.discount)).toFixed(2)}</div>
                      {!isView &&<div>
                        <MinusOutlined 
                          onClick={() => handleChangeQuantity(product, 'minus')}
                        />
                        <Input 
                          // type='number' 
                          value={quantity[product?.product?._id] || 0} 
                          onChange={(e) => handleChangeQuantity(product, 'change', e)}
                          min={product.minQuantity}
                          max={product.maxQuantity || undefined}
                          style={{width: '40px', textAlign: 'center', borderRadius: '5px', margin: '0 5px'}}
                        />

                        <PlusOutlined
                          onClick={() => handleChangeQuantity(product, 'plus')}
                        />
                      </div>}
                      {!isView && <div>${subTotals[product?.product?._id]?.toFixed(2)}</div>}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div>
          <CustomButton onclick={handleClose} color="btnOutline" size="bg" content="CERRAR" />
          {!isView && <CustomButton onclick={() => handleSubmit()} color="btnPrimary" size="bg" content="CONFIRMAR">
            <ShoppingOutlined />
          </CustomButton>}
        </div>
      </div>
    </Modal>
  );
};

export {OpenCombo};
